// src/modules/app-views/_apps/appmulti/plans/pages/Init/actions/actionButton.js

import { PlusOutlined } from '@ant-design/icons';

const plansInitActionButton = () => {
  return {
    action: 'new',
    hideButton: false,
    label: 'new',
    tooltip: 'new_plan',
    icon: <PlusOutlined />,
    type: 'primary',
    disabled: false,

    // Primary button handler - navigation to add new document
    onClick: ({ navigate, setPage }) => {
      setPage({
        navigate,
        pageName: 'document',
        params: { _id: 'add' },
      });
    },

    // No dropdown for this button
    dropdownItems: [],
  };
};

export default plansInitActionButton;
